// Tiny in-memory cache shared across admin pages (Dashboard, Orders, …).
//
// Why this exists: every admin tab did a fully blocking fetch-then-render on
// every mount, so switching Orders -> Dashboard -> Orders re-ran every query
// from scratch and showed a full-page spinner each time — slow and janky
// even though nothing had actually changed since the last visit seconds ago.
//
// This is a module-level Map, not React state, so it survives component
// unmount/remount across route changes within the same page load (a hard
// refresh naturally clears it — that's fine, it's a perceived-speed cache,
// not a source of truth). Pages should read the cache synchronously on
// mount to paint instantly, then re-fetch in the background ("stale while
// revalidate") and update both the cache and the screen once the fresh
// response lands — never block the UI on the refetch.
const store = new Map();

export function getCached(key) {
  return store.has(key) ? store.get(key) : undefined;
}

export function setCached(key, value) {
  store.set(key, value);
}
